import type { getAllProperties_properties as PropertyRow } from "types/gql-types";

type AdminPropertyTableFilters = {
  showArchived: boolean;
  organizationId: string | null;
};

export const filterAdminProperties = (
  properties: PropertyRow[],
  filters: AdminPropertyTableFilters,
): PropertyRow[] => {
  let rows = properties;
  if (!filters.showArchived) {
    rows = rows.filter((p) => !p.interestList.isArchived);
  }
  if (filters.organizationId) {
    rows = rows.filter((p) => p.organization?.id === filters.organizationId);
  }
  return rows;
};
